import Modal from "@mui/material/Modal";
import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { obtenerCotizacionId } from "../../../store/cotizaciones/thunkCotizaciones";
import { getSpecificLead } from "../../../store/clientes/thunkClientes";
import { obtenerAdministrador } from "../../../store/admin/thunkAdmins";
import { getSpecificempresa } from "../../../store/Empresa/thunkEmpresa";
import { useNavigate } from "react-router-dom";
import { etiquetas, logos } from "../../../hook/Arreglos";

export const DetalleCotizacionModal = ({ open, handleClose, data }) => {
    // Importación de hooks y funciones necesarias
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Estados para almacenar datos y estado de carga
    // Estado para almacenar los datos de la cotización actual
    const [cotizacion, setCotizacion] = useState({});
    // Estado para almacenar los datos del cliente asociado a la cotización
    const [cliente, setCliente] = useState({});
    // Estado para almacenar los datos de la empresa relacionada con el cliente
    const [empresa, setEmpresa] = useState({});
    // Estado para almacenar los datos del administrador asociado a la cotización
    const [admin, setAdmin] = useState({});
    // Estado para controlar si la aplicación está en proceso de cargar datos
    const [isLoading, setIsLoading] = useState(true);

    // Función para formatear una fecha en un formato legible
    const formatearFecha = (fecha) => {
        // Convierte la fecha en un objeto Date
        var fechaObjeto = new Date(fecha);
        // Opciones de formato para mostrar día de la semana, día, mes y año
        var opcionesDeFormato = { weekday: "long", day: "numeric", month: "long", year: "numeric" };
        // Devuelve la fecha formateada en español
        return fechaObjeto.toLocaleDateString("es-ES", opcionesDeFormato);
    };

    // Función para obtener los datos de la cotización específica, junto con sus relaciones
    const fetchCotizacion = useCallback(
        async (idConsecutivo) => {
            setIsLoading(true); // Indica que los datos están cargándose
            try {
                // Obtiene los datos de la cotización desde la API mediante Redux
                const result = await dispatch(obtenerCotizacionId(idConsecutivo));
                // Configura el estado con los datos de la cotización
                setCotizacion({
                    id_hotel_coti: result?.id_hotel_coti || 0, // ID del hotel asociado a la cotización
                    nombre_evento_coti: result?.nombre_evento_coti || "N/A", // Nombre del evento en la cotización
                    id_consecutivo_coti: result?.id_consecutivo_coti || "N/A", // ID único consecutivo de la cotización
                    fecha_cotizacion: formatearFecha(result?.fecha_creacion_coti) || "", // Fecha de creación de la cotización, formateada
                    fecha_evento_coti: result?.fecha_evento_coti || "", // Fecha del evento asociado a la cotización
                    Estado_coti: result?.Estado_coti || "", // Estado de la cotización
                });

                // Obtiene los datos del cliente asociado mediante su ID
                const leadData = await dispatch(getSpecificLead(result.cliente_coti));
                // Configura el estado con los datos del cliente
                setCliente({
                    id_cliente: leadData?.id_cliente || 0, // ID del cliente
                    nombre_cliente: leadData?.nombre_cliente || "", // Nombre del cliente
                    telefono_cliente: leadData?.telefono_cliente || "", // Teléfono del cliente
                });

                // Obtiene los datos del administrador asignado a la cotización
                const adminData = await dispatch(obtenerAdministrador(result.admin_coti));
                // Configura el estado con los datos del administrador
                setAdmin({
                    name_admin: adminData?.name_admin || "", // Nombre del administrador
                    puesto: adminData?.puesto || "", // Puesto o cargo del administrador
                    email_admin: adminData?.email_admin || "", // Correo electrónico del administrador
                    phone_admin: adminData?.phone_admin || "", // Teléfono del administrador
                });

                // Obtiene los datos de la empresa asociada al cliente
                const empresaData = await dispatch(getSpecificempresa(leadData?.id_empresa));
                // Configura el estado con los datos de la empresa
                setEmpresa({
                    id_empresa: empresaData?.id_empresa || 0, // ID de la empresa
                    nombre_empresa: empresaData?.nombre_empresa || "", // Nombre de la empresa
                });
            } catch (error) {
                // Maneja errores y reinicia los estados en caso de fallo
                console.error("Error al obtener la cotización:", error);
                setCotizacion({});
                setCliente({});
                setAdmin({});
                setEmpresa({});
            } finally {
                setIsLoading(false); // Finaliza el estado de carga
            }
        },
        [dispatch], // Dependencia de Redux Dispatch
    );

    // Función para asignar un logo en función del ID del hotel
    const asignarLogo = (idHotel) => {
        // Busca el logo correspondiente al ID del hotel en el array de logos
        const hotel = logos.find((item) => item.id === idHotel);
        // Devuelve el logo encontrado o una cadena vacía si no hay coincidencia
        return hotel ? hotel.logo : "";
    };

    // Función para asignar una etiqueta en función del ID del hotel
    const asignarEtiqueta = (idHotel) => {
        // Busca la etiqueta correspondiente al ID del hotel en el array de etiquetas
        const hotel = etiquetas.find((item) => item.id === idHotel);
        // Devuelve la etiqueta encontrada o una cadena vacía si no hay coincidencia
        return hotel ? hotel.logo : "";
    };

    // Hook useEffect para cargar los datos de la cotización cuando cambia `data.id_coti`
    useEffect(() => {
        // Verifica que exista un ID de cotización antes de intentar cargar datos
        if (data?.id_coti) {
            fetchCotizacion(data.id_coti); // Llama a la función para obtener los datos
        }
    }, [data, fetchCotizacion]); // Dependencias del efecto

    // Función para navegar a la vista de una cotización específica
    const verCotizacion = () => {
        navigate(`/cotizaciones/view?data=${data.id_coti}`); // Redirige a la página de visualización
    };

    // Función para navegar a la vista de edición de una cotización específica
    const EditarCotizacion = () => {
        navigate(`/cotizaciones/editar?data=${data.id_coti}`); // Redirige a la página de edición
    };

    // Función para navegar a la vista de copia de una cotización específica
    const CopiarCotizacion = () => {
        navigate(`/cotizaciones/copia?data=${data.id_coti}`); // Redirige a la página de copia
    };

    const crarContrato = () => {
        navigate(`/contratos/crear?data=${data.id_coti}`); // Redirige a la página de copia
    };

    function getAlertClass(estado) {
        console.log(estado);
         switch (estado) {
             case "Confirmada":
                 return "success";
             case "Pendiente":
                 return "warning";
             case "Tentativa":
                 return "primary";
             case "Perdida":
                 return "danger";
             case "Enviado":
                 return "dark";
             default:
                 return "secondary"; // Clase por defecto, opcional
         }
     }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            className="modal fade show"
            aria-labelledby="DetalleCotizacionModal"
            style={{ display: "block" }}
            aria-modal="true"
        >
            <div className="modal-dialog" style={{ maxWidth: "80%", margin: "1.75rem auto" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <h2 style={{ fontSize: "15px", fontWeight: "bold" }} className="float-end">
                            COTIZACIÓN DE SERVICIOS # {cotizacion.id_consecutivo_coti}
                        </h2>

                        <div className="zoom-gallery d-flex flex-wrap">
                            <img src={asignarLogo(cotizacion.id_hotel_coti)} alt="Logo del hotel" width="200" />
                        </div>

                        <div className="card">
                            <div className="card-header">
                                <h5>Información principal de la cotización</h5>
                                <br />
                                <div role="alert" className={`fade alert alert-${getAlertClass(cotizacion.Estado_coti)} show`}>
                                    Estado : {cotizacion.Estado_coti}
                                </div>
                                <br />
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <button className="btn btn-danger" onClick={() => verCotizacion()}>
                                        {" "}
                                        Ver Cotización
                                    </button>
                                    <button className="btn btn-info" onClick={() => CopiarCotizacion()}>
                                        Generar Copia
                                    </button>
                                    <button className="btn btn-warning" onClick={() => EditarCotizacion()}>
                                        Editar Cotización
                                    </button>
                                    <button className="btn btn-success" onClick={() => crarContrato()}>
                                        Generar Contrato
                                    </button>
                                </div>
                                <br />
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <button className="btn btn-dark" onClick={() => navigate(`/clientes/perfil?data=${cliente.id_cliente}`)}>
                                        Ver Cliente
                                    </button>
                                    <button className="btn btn-dark" onClick={() => navigate(`/empresas/perfil?data=${empresa.id_empresa}`)}>
                                        Ver empresa
                                    </button>
                                </div>
                            </div>

                            <div className="card-body">
                                {isLoading ? (
                                    // Preloader mientras se cargan los datos
                                    <div className="preloader-container" style={{ textAlign: "center", padding: "20px" }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                        <p>Cargando datos, por favor espere...</p>
                                    </div>
                                ) : (
                                    // Tabla de datos (se muestra solo cuando `isLoading` es false)
                                    <div className="table-responsive">
                                        <table className="table table-striped-columns mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ textAlign: "center", backgroundColor: "#626060", color: "#fff", fontSize: "12px" }}>
                                                        CONTACTO DEL HOTEL
                                                    </th>
                                                    <th></th>
                                                    <th style={{ fontSize: "12px" }}>Fecha Cotización:</th>
                                                    <th>{cotizacion.fecha_cotizacion}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th style={{ fontSize: "12px" }}>Ejecutiva</th>
                                                    <td>{admin.name_admin}</td>
                                                    <td style={{ fontSize: "12px" }}>Fecha Evento:</td>
                                                    <td>{cotizacion.fecha_evento_coti}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ fontSize: "12px" }}>Cargo</th>
                                                    <td>{admin.puesto}</td>
                                                    <td style={{ fontSize: "12px" }}>Nombre Evento:</td>
                                                    <td>{cotizacion.nombre_evento_coti}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ fontSize: "12px" }}>Departamento</th>
                                                    <td>Mercadeo y Ventas</td>
                                                    <td style={{ fontSize: "12px" }}>Empresa:</td>
                                                    <td>{empresa.nombre_empresa}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ fontSize: "12px" }}>Correo Electrónico</th>
                                                    <td>{admin.email_admin}</td>
                                                    <td style={{ fontSize: "12px" }}>Contacto</td>
                                                    <td>{cliente.nombre_cliente}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ fontSize: "12px" }}>Teléfono</th>
                                                    <td>{admin.phone_admin}</td>
                                                    <td style={{ fontSize: "12px" }}>Teléfono Cliente</td>
                                                    <td>{cliente.telefono_cliente}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <center>
                                            <img
                                                src={asignarEtiqueta(cotizacion.id_hotel_coti)}
                                                className="img-thumbnail"
                                                style={{
                                                    width: "50%", // Ajusta el tamaño al 50% del contenedor
                                                    height: "auto",
                                                    opacity: 0.7, // Aplica transparencia (0.0 es totalmente transparente, 1.0 es opaco)
                                                }}
                                            />
                                        </center>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
